module.exports = __webpack_public_path__ + "static/media/glaucoma.3c199277.svg";